import { Component } from '@angular/core';
import { AlertController, ModalController } from 'ionic-angular';

import { ExerciseModel } from '../../models/models';
import { ConfigurationProvider, ExerciseProvider } from '../../providers/providers';
import { ExerciseEditPage } from './exercise-edit';

@Component({
  selector: 'page-exercise-list',
  templateUrl: 'exercise-list.html',
})
export class ExerciseListPage {
  exerciseList: any = [];
  page: string = 'exercises';

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private exerciseProvider: ExerciseProvider,
    private modalCtrl: ModalController) {
  }

  doAdd(item: ExerciseModel = new ExerciseModel()) {
    let modal = this.modalCtrl.create(ExerciseEditPage, { 
      item: item
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved && data.name) {
        this.config.showToast('"' + data.name + '" saved!');
        this.loadView();
      }
    });
  }

  doRemove(item: ExerciseModel) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure? This exercise will also be removed from all exercise routines where it is used, but daily data logged using the exercise will remain.',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            this.config.showLoading();
            this.exerciseProvider.Remove(item).then((items) => {
              this.exerciseList = items;
              this.config.showToast(item.Name + ' removed!');
              this.config.dismissLoading();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  ionViewDidLoad() {
    this.loadView();
  }

  loadView() {
    this.exerciseList = this.exerciseProvider.Sort();
    if (this.exerciseList.length === 0) {
      this.config.showLoading();
      this.exerciseProvider.List().then((items) => {
        this.exerciseList = items;
        this.config.dismissLoading();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/exercises/exercise-list.ts